import { render, staticRenderFns } from "./giftsApproval.vue?vue&type=template&id=1f25ca65&scoped=true"
import script from "./giftsApproval.vue?vue&type=script&lang=js"
export * from "./giftsApproval.vue?vue&type=script&lang=js"
import style0 from "./giftsApproval.vue?vue&type=style&index=0&id=1f25ca65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25ca65",
  null
  
)

export default component.exports